import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={47}
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            >
            <rect x={0.5} y={0.898438} width={45} height={45} rx={22.5} fill="#fff" />
            <rect
                x={0.5}
                y={0.898438}
                width={45}
                height={45}
                rx={22.5}
                stroke={theme["#0EA59D"]}
            />
            <path
                d="M29.642 14.855h-2.45c-1.059 0-1.692.634-1.692 1.692v2.45c0 1.058.633 1.692 1.692 1.692h2.45c1.058 0 1.691-.634 1.691-1.692v-2.45c0-1.058-.633-1.692-1.691-1.692zm.183 2.759c-.1.1-.233.15-.367.15a.517.517 0 01-.366-.15l-.15-.15v1.867a.523.523 0 01-.525.524.523.523 0 01-.525-.524v-1.867l-.15.15c-.2.2-.534.2-.734 0-.2-.2-.2-.534 0-.733l1.042-1.042a.513.513 0 01.158-.1c.017-.009.034-.009.05-.017a.347.347 0 01.134-.025h.05c.058 0 .108.009.166.034h.017a.473.473 0 01.15.1c.008.008.008.008.017.008l1.041 1.042c.2.2.2.533-.008.733zM14.666 22.95v4.166a3.446 3.446 0 003.45 3.45h9.758a3.46 3.46 0 003.459-3.458V22.95c0-.559-.45-1.009-1.009-1.009h-14.65c-.558 0-1.008.45-1.008 1.009zm5 4.825h-1.667a.63.63 0 01-.625-.625.63.63 0 01.625-.625h1.667a.63.63 0 01.625.625.63.63 0 01-.625.625zm5.417 0h-3.334a.63.63 0 01-.625-.625.63.63 0 01.625-.625h3.334a.63.63 0 01.625.625.63.63 0 01-.625.625zM24.25 17.239v2.441c0 .559-.45 1.009-1.009 1.009h-7.567a1.015 1.015 0 01-1.008-1.025c.008-.942.383-1.8 1.008-2.425a3.446 3.446 0 012.442-1.009h5.125c.558 0 1.008.45 1.008 1.009z"
                fill={theme["#0D968F"]}
            />
        </svg>
      )
}
  
  export default SvgComponent